import React, { forwardRef, useEffect, useState } from "react";
import Label from "../../ui/Label";
import DateInput from "../../ui/DateInput";
import TimeInput from "../../ui/TimeInput";
import { ROUTES } from "../../utils/Routes";
import { useTabs } from "../../hooks/useTabs";
import Space from "../../ui/Space";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import { pubCall } from "../../utils/PubSub";
import { FILTER } from "../../utils/Struct";
import { showError } from "../../ui/Message";
import { bm_date, bm_time, updateOrdering } from "../../utils/Utils";
import Spin from "../../ui/Spin";
import Input from "../../ui/Input";

const InvoicesBetween = forwardRef(function ReportFilter(props, ref) {


    const { controller = "", escape = () => { }, report = {}, height = 260, goto = () => { }, setReport = () => { }, where_type = "AND", edit = false, show_add = false, small = false, headerClass = "", showColumnHeaders = true, header = "",

        onFocus = () => { },
        onBlur = () => { },
        onClick = () => { },

        callback = () => {

        }

    } = props;

    const route = ROUTES.REPORTS.FILTER_INVOICES_BETWEEN;
    const [loading, setLoading] = useState(false)



      // console.log(report)


    const onSave = (exit = false) => {

        setLoading(true);

        let v1 = getVal("from");
        let v2 = getVal("to");

        let _filters = report.filters.filter(item => !([-6, -5, -1].includes(item.type)) && item.where_type === "AND");
        if(v1 || v2){
             _filters.unshift({ ...FILTER, "type": -6, "where_type": "AND", value_1: v1, value_2: v2 })
        }
       
        _filters = updateOrdering(_filters);


        pubCall("report.purgeAndReplaceFilters", { report_id: report.report_id, filters_info: _filters, filter_where_type: "AND" }, (_s, _r) => {
            if (_s) {
                setReport(_r);
                if (exit) {
                    escape();
                }

            } else {
                showError(_r);
            }
            setLoading(false)
        })



    }

    const invoices_between = report.filters?.find(item => item.type === -6);
    const _from = (invoices_between?.value_1) ? invoices_between?.value_1 : "";
    const _to = (invoices_between?.value_2) ? invoices_between?.value_2 : "";



    const defaultTabs = [
        { set: "scope", label: "from", key: "from", value: _from },
        { set: "scope", label: "to", key: "to", value: _to },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "");



    useEffect(() => {
        if (edit) {
            window.bm_state.value = route;
            setIndex("from");
        } else {
            if (index !== "") {
                setIndex("")
            }
        }
    }, [edit]);

    useEffect(() => {
        if (refs?.current[index]) refs.current[index].focus();

    }, [index, edit]);

    useEffect(() => {

        if (props.autoSave && props.autoSave === props.autoKey) {
            props.setAutoSave(false);
            onSave(true, tabs);
        }


        const actions = [
            { key: KBD.ESCAPE, action: () => escape() },
            { key: KBD.SHIFT_TAB, action: () => { if (index === "from") { goto("scope_type") } else { next(); } } },
            { key: KBD.TAB, action: () => { if (index === "to") { onSave(); goto("sales_types") } else { next(); } } },
            { key: KBD.ENTER, action: () => { if (index === "to") { onSave(); goto("sales_types") } else { next(); } } },
            { key: KBD.ARROW_DOWN, action: () => { if (index === "to") { onSave(); goto("sales_types") } else { next(); } } },
            { key: KBD.ARROW_UP, action: () => { if (index === "from") { goto("scope_type") } else { prev(); } } },
            { key: KBD.PAGE_DOWN, action: () => onSave(true) },
        ];
        return listen(controller, route, actions, () => { }, [
            KBD.TAB,
            KBD.SHIFT_TAB,
            KBD.ENTER,
            KBD.PAGE_DOWN,
            KBD.ARROW_DOWN,
            KBD.ARROW_UP,
            KBD.ESCAPE
        ]);
    }, [index, tabs]);


 

    return (
        <div className="no-focus" onBlur={() => onBlur()} onFocus={() => onFocus()} onClick={() => onFocus()} ref={ref} tabIndex={0}>
            <Space>
                <Label >Invoice between</Label>
                <div>
                    <Input show_preset={true} cycle={["yesterday", "today"]} route={route} shrink={false} width={95} {...editProps("from")} onFilled={() => next()} onClick={() => (index !== "from") && setIndex("from")} onBlur={(e) => { update("from", e) }} edit={edit} />
                </div>

                <Label>and</Label>
                <div>
                    <Input show_preset={true} cycle={["today", "yesterday"]} route={route} shrink={false} width={95} {...editProps("to")} onFilled={() => next()} onClick={() => (index !== "to") && setIndex("to")} edit={edit} />
                </div>

            </Space>
        </div>
    )
});

export default InvoicesBetween;